
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/[username]",
      function () {
        return require("private-next-pages/u/[username]/index.js");
      }
    ]);
  